import api from './api';

const notificationService = {
  // Récupérer les notifications de l'utilisateur courant (limitées côté backend)
  async list() {
    const response = await api.get('/auth/notifications/');
    return response.data;
  },

  // Marquer une notification comme lue
  async markRead(id) {
    if (!id) return;
    await api.post(`/auth/notifications/${id}/mark-read/`);
  },

  // Tout marquer comme lu
  async markAllRead() {
    await api.post('/auth/notifications/mark-all-read/');
  },
};

export default notificationService;
